import React from "react";
import Styles from "./DetailHeader.module.css";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";

const DetailHeader = ({ heading, list, handleSelect }) => {
  const navigate = useNavigate();
  return (
    <div className={Styles.detailsTopbar}>
      {/* LEFT SECTION */}
      <div className={Styles.detailsLeftSection}>
        {/* BACK BUTTON */}
        <div onClick={() => navigate(-1)} className={Styles.premiumBackButton}>
          <div className={Styles.backIconWrapper}>
            <ArrowBackIosIcon className={Styles.premiumBackIcon} />
          </div>

          <div className={Styles.backTextWrapper}>
            <span className={Styles.backLabel}>Back</span>

            {/* <span className={Styles.backSubText}>Return to previous page</span> */}
          </div>
        </div>

        {/* PAGE TITLE */}
        <div className={Styles.pageTitleWrapper}>
          <div className={Styles.pageHeading}>{heading}</div>

          
        </div>
      </div>

      {/* RIGHT FILTERS */}
      <div className={Styles.filterPillWrapper}>
        {list?.map((ele, index) => (
          <div
            key={index}
            className={`${Styles.filterPill} ${
              ele?.status ? Styles.activeFilterPill : ""
            }`}
          >
            <span>{ele?.name}</span>

            {ele?.count >= 0 && (
              <div className={Styles.filterCountBadge}>{ele?.count}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailHeader;
